import { render, staticRenderFns } from "./BrandUser.vue?vue&type=template&id=3ef229f3"
import script from "./BrandUser.vue?vue&type=script&lang=js"
export * from "./BrandUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports